export default __webpack_public_path__ + "static/media/img_10.8b254699.JPG";